export default "__VITE_ASSET__CDeQSPS9__"